<div
  class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
>
  <app-icon [name]="name" [strokeWidth]="strokeWidth" [fill]="fill"></app-icon>
</div>
